import { render, staticRenderFns } from "./InfoTopicCard.vue?vue&type=template&id=740a49cd&scoped=true&"
import script from "./InfoTopicCard.vue?vue&type=script&lang=js&"
export * from "./InfoTopicCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740a49cd",
  null
  
)

export default component.exports